// extracted by mini-css-extract-plugin
export default {"root":"DataConnectorPickerButton_root__QrLAS","label":"DataConnectorPickerButton_label__MXyZb","name":"DataConnectorPickerButton_name__TpRLc"};